import React, { createContext, useContext, useState, useRef } from 'react';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const idRef = useRef(0);

  const remove = (id) => {
    setNotifications((list) => list.filter((n) => n.id !== id));
  };

  const push = (type, message, duration = 4500) => {
    idRef.current += 1;
    const id = idRef.current;
    setNotifications((list) => [...list, { id, type, message }]);
    if (duration > 0) {
      setTimeout(() => remove(id), duration);
    }
    return id;
  };

  const value = {
    notifications,
    remove,
    success: (msg, d) => push('success', msg, d),
    error:   (msg, d) => push('error', msg, d),
    info:    (msg, d) => push('info', msg, d),
    warning: (msg, d) => push('warning', msg, d),
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotify() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotify must be inside NotificationProvider');
  return ctx;
}
